import { IRequirementViewModel } from "../../../interfaces/RequirementsInScopeModel";
import CalendarPicker from "../../portico/calendar-picker/calendar-picker"; 
import AutoComplete from "../../portico/autocomplete/autocomplete";
import Checkbox from "../../portico/checkbox/checkbox";
import Textarea from "../../portico/textarea/textarea";
import Spacing from "../../portico/spacing/spacing";
import FormInput from "../../portico/input/form-input";
import Radiogroup from "../../portico/radiogroup/radiogroup";
import InputLabel from "../../portico/input-label/input-label";
import { Typography, InputAdornment } from "@material-ui/core";
import moment from 'moment';
import { styled } from '@mui/material/styles';
import { FormDataGroups } from './form-data-groups';
import { getFormFieldValue, parseClassificationAttribute, showFieldLabel } from './form-helper-methods';
import { DocumentsRenderer } from './documents-renderer';
import { JourneyDocument } from "../../../interfaces/JourneyDocument.interface";
import CONSTANTS from "../../../utils/constants";
import { CodatButton } from "../custom-codat-button";
import { PropertyType } from "../../../interfaces/EntityViewModel";
import { formatDate } from "../../../utils/format-date";
import { CodatState } from "../../../stores/ui/ui-state";
import { connect } from "http2";
import FormattedInputs from "./formatted-input";
import { isFixedHelpTooltip } from "./form-helper-methods";
import { isCodatConnectionSuccessful } from "../../../utils/codat-utils";
import { formatHelpText, isOptionalField } from "../../../utils/common-utils";
import React, { useState } from "react";
import { gridColumnsTotalWidthSelector } from "@mui/x-data-grid";

// remove this label after we move all the compnents to outlined and label inside them
export const renderFieldLabel = (field, formFieldRendererStyles, currentTaskName?) => {
  let uiMetaData: any = parseClassificationAttribute(field.classification);
  if (uiMetaData && (uiMetaData.hideField || uiMetaData.hideLabel)) {
    return <> </>
  }

  // TODO: Remove 3-year-old TODO item...
  // Todo: remove hardcoded field names
  const checkWhetherToHighLightTheText = () => {
    const propertyName = ["toExpediteYourApplicationTakeAMomentToReviewAndConfirmYourInformation",
      "tellUsAboutYourOwnMilestonesDisclaimer",
      "tellUsAboutYourOwnMilestonesDisclaimer",
      "milestone1",
      "milestone2"
    ];
    return propertyName.includes(field.dataField.propertyName);
  }

  const checkWhetherMilestoneLabelText = () => {
    const propertyName = [
      "mstone2",
      "mstone1",
      "headquartersAddressTitle"
    ];
    return propertyName.includes(field.dataField.propertyName);
  }

  return (
    showFieldLabel(field, uiMetaData) && (
      <div className={checkWhetherToHighLightTheText() ? formFieldRendererStyles.labelText : ''}>
        <div className={checkWhetherMilestoneLabelText() ? formFieldRendererStyles.milestoneLabelText : ''}>
          {/* <div className={currentTaskName = "Review and Submit" && formFieldRendererStyles.greySpan}> */}
          <div className={currentTaskName = "Review and Submit"}>
            <InputLabel
              fieldName={field.name}
              fieldDescription={formatHelpText(field.description)}
              fieldExternalLinkUrl={uiMetaData?.externalLinkUrl}
              fieldExternalLinkText={uiMetaData?.externalLinkText}
            />
          </div>
        </div>
      </div>
    )
  );
}


const CustomTextArea = styled(Textarea)({
  height: '82px',
  padding: '0px',
  "& div:nth-child(2)": { height: '0px' },
  "& div": {
    height: '82px',
  },
  "& textarea": {
    height: '82px',
    color: ' #212121',
  },
  "& :focus": {
    border: "2px solid var(--input-focus-border-color)",
  }
});

// Form Rendering Flow - Step 5. This is just a giant switch statement. Depending on the type of field
// (text, select, etc.) the function returns the appropriate element. And this is the end of the Form Rendering FLow.
export const renderDataField = (
  fieldName: string, field: IRequirementViewModel, value: any,
  formMethods: any, onChange: Function,
  loading: boolean, readOnly: boolean, labelInsteadOfControl: boolean,
  journeyId: string, entityId: string,
  dataGroupReqsInScope: IRequirementViewModel[], dynamicDataGroupRequirements: Array<object>,
  lookupList: Array<object>, lookupLinks: Array<object>, dataGroupsSettings: Array<object>,
  initialValues: any, documents: JourneyDocument[], requirementsInScope: IRequirementViewModel[],
  lookups: Array<object> = [], codatState: CodatState, handleOpenSyncModal?: Function

) => {
  let filteredLookupList, filteredLookupLinkList;
  let options;
  const { register, setValue, getValues, errors, watch, unregister } = formMethods;
  let uiMetaData: any = parseClassificationAttribute(field.classification);
  const isDisplayLabel = !uiMetaData || !uiMetaData.hideLabel || showFieldLabel(field, uiMetaData);
  const validationsRules = field.validationRule?.validationData || {};
  const mandatoryRule = validationsRules.isMandatory || {};
  const isRequired = mandatoryRule.active || false;
  const reqValidationMessage = mandatoryRule.message;
  const multiSelectMax = validationsRules.multiSelectLimit != null ? validationsRules.multiSelectLimit.maxValue : null;
  const errorMessage = validationsRules.multiSelectLimit != null ? validationsRules.multiSelectLimit.message : null;

  const characterLimitRule = validationsRules.characterLimit || {};
  const minValue = characterLimitRule.minValue;
  const maxValue = characterLimitRule.maxValue;
  const minMaxValidationMessage = characterLimitRule.message;
  
  const regexRule = validationsRules.regex || {};
  const regexApplied = regexRule.active;
  const regexValue = regexRule.regexValue;
  const regexValidationMsg = regexRule.message;

  const unregisterField = () => {
    if (unregister) {
      // Unregister the field from the form, so that it is not returned in the form values
      unregister(fieldName)

      // Since the value is removed from the form  we need to invoke onChange
      // which will take care of showing/hiding other dependent fields
      if (!fieldName.includes('dataGroup_')) onChange();
    }
  }

  // Document Requirements
  if (field.type === 'Document') {
    // Untill the documentType is returned from FENX as a meta data
    // Create it using the documentDataKey and append "Type" to it
    const documentType = getFormFieldValue(getValues, `${field.documentDataKey}Type`);
    const componentKey = `${field.documentDataKey}-${documentType}`;
    const documentMeta = { documentType: `${field.documentDataKey}Type`, documentName: documentType }

    return (
      <DocumentsRenderer
        dataSource={[field]}
        documentDescription={formatHelpText(field.description)}
        journeyId={journeyId}
        journeyDocuments={documents}
        loadingDocuments={false}
        entityId={entityId}
        showLabel={false}
        key={componentKey}
        metaData={uiMetaData}
        error={errors[fieldName] || errors[field.identifier]}
        register={register(fieldName, {
          required: {
            value: !isOptionalField(fieldName),
            message: CONSTANTS.GENERIC_FILE_REQUIRED_MESSAAGE
          },
        })}
        unregister={unregisterField}
        name={fieldName}
        setValue={setValue}
        documentMeta={documentMeta}
        deleteRequired={false}
      />
    )
  }

  // Read Only fields
  if (field.isReadOnly || readOnly) {
    register(fieldName);
    setValue(fieldName, value ? value : field.defaultValue);
    let displayValue = value;
    if (field.dataField.propertyType === "date") {
      const inputFormat = uiMetaData?.dateFormat || CONSTANTS.DEFAULT_DATE_FORMAT
      displayValue = formatDate(value, inputFormat);
    }
    let valueData = value;
    if (uiMetaData && uiMetaData.currency && field.dataField.propertyType === 'number') {
      if(Number.isNaN(valueData) || valueData == undefined) {
        displayValue = "None";
      } else {
        displayValue = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        }).format(valueData)
      }
    }
    if(field.dataField.propertyType == "multiselect") {
      displayValue = value.split("|");
    }


    return (
      <>
        <Spacing variable="spacing-base" />
        {(displayValue instanceof Array) ?
          displayValue.map((value) => 
            <Typography style={{ color: "#212121" }} variant="body1">{value}</Typography>    
          ) :
          <Typography style={{ color: "#212121" }} variant="body1">{displayValue}</Typography>
        }
        {/* <Typography style={{ color: "#212121" }} variant="body1">{displayValue}</Typography> */}
        {(!uiMetaData || !uiMetaData.hideValue) && <Typography variant="body1">{field.defaultValue}</Typography>}
        <input
          type="hidden"
          name={fieldName}
          value={value}
        />
      </>
    )
  }
  // Hidden fields
  if (uiMetaData && (uiMetaData.hideField === true || uiMetaData.hideField === "true")) {
    register(fieldName);
    setValue(fieldName, field?.defaultValue ?? value);
    return (
      <input
        type="hidden"
        name={fieldName}
        value={field?.defaultValue}
      />
    )
  }

  if (uiMetaData && uiMetaData.fieldType) {
    switch (uiMetaData.fieldType) {
      case "checkboxes":
        let hiddenCheckbox: boolean = false;
        if (fieldName === "uploadAccountingDocumentsManually" && isCodatConnectionSuccessful(codatState)) {
          value = CONSTANTS.NO
          hiddenCheckbox = true;
        }
        register(fieldName);
        setValue(fieldName, value);

        const style = hiddenCheckbox ? {display: 'none'} : {}
        return (
          <div style={style}>
          <Checkbox
            name={fieldName}
            label={field.name}
            value={value}
            onChange={onChange}
            setValue={setValue}
          /></div>
        );
      case "radiobuttons":
        let filterLookupList = lookupList && lookupList.filter(x => x["lookupId"] === field.dataField.propertyTypeId)[0];
        let options = filterLookupList ? filterLookupList["values"].map(value => { return { label: value, value: value } }) : [];

        return (
          <Radiogroup
            name={fieldName}
            label={field.name}
            items={options}
            inputRef={register({
              required: {
                value: isRequired,
                message: reqValidationMessage
              },
              validate: value => {
                if(!value){
                  return 'Field must be a Required.'
                }
              }
            })}
            unregister={unregisterField}
            value={value}
            error={errors[fieldName] || errors[field.identifier]}
            onChange={(event, value) => onChange()}
          />
        );
    }
  }

  switch (field.dataField.propertyType) {
    case "textArea":
      return (
        <CustomTextArea
          label={field.name}
          name={fieldName}
          value={value}
          isRequired={isRequired}
          onChange={(e) => { onChange() }}
          inputRef={register({
            required: {
              value: isRequired,
              message: reqValidationMessage
            },
            minLength: {
              value: minValue,
              message: minMaxValidationMessage
            },
            maxLength: {
              value: maxValue,
              message: minMaxValidationMessage
            },
          })}
          error={errors[fieldName] || errors[field.identifier]}
          min={minValue}
          max={maxValue}
          setValue={setValue}
          unregister={unregisterField}
        />
      );
    case "text":
      if (fieldName === 'thisDataWillBeUsedToIdentifyProductOptionsForYou') {
        return (<CodatButton
          handleOpenSyncModal={handleOpenSyncModal}
          setValue={setValue}
          register={register}
          unregister={unregister}
          name={fieldName}
          value={value}
        />
        )
      } else if (fieldName === 'codatCompanyId') {
        register(fieldName);
        const codatCompanyId = codatState.companyId ? codatState.companyId : value;
        setValue(fieldName, codatCompanyId);
        return (
          <input
            type="hidden"
            name={fieldName}
            value={codatCompanyId}
          />
        );
      }
      else 
      {
        const specialCharactersRule = validationsRules.specialCharacters || {};
        const excludedSpecialCharacters = specialCharactersRule.excludedCharacters;
        const excludedSpecialCharactersMsg = specialCharactersRule.message;
        let showAsterisk = false
        
        return (
          <FormInput
            name={fieldName}
            label={field.name}
            isDisplayLabel={isDisplayLabel}
            isRequired={showAsterisk}
            fieldDescription={formatHelpText(field.description)}
            fieldExternalLinkUrl={uiMetaData?.externalLinkUrl}
            fieldExternalLinkText={uiMetaData?.externalLinkText}
            value={value}
            ref={register({
              required: {
                value: isRequired,
                message: reqValidationMessage
              },
              minLength: {
                value: minValue,
                message: minMaxValidationMessage
              },
              maxLength: {
                value: maxValue,
                message: minMaxValidationMessage
              },
              validate: value => {
                //To-Do This logic should refactor
                if (value && excludedSpecialCharacters) {
                  let tempValue = value.replace(/[a-zA-Z0-9]+|\s+/gmi, '')
                  excludedSpecialCharacters.forEach(specialCharacter => {
                    if (tempValue && tempValue.trim().length > 0) {
                      tempValue = tempValue.replaceAll(specialCharacter, '')
                    }
                  })
                  if (tempValue.trim().length > 0) {
                    return excludedSpecialCharactersMsg
                  }
                }
                if (value && regexApplied && !value.match(regexValue)) {
                  return regexValidationMsg
                }
              }
            })}
            error={errors[fieldName] || errors[field.identifier]}
            setValue={setValue}
            register={register}
            unregister={unregister}
            max={maxValue}
            onChange={() => onChange()}
            {...register(fieldName, {
              required: {
                value: isRequired,
                message: reqValidationMessage
              },
            })}
          />
        )
      }
    case "number":
      const numberLimitRule = validationsRules.numberLimit || {};
      const minNumberValue = numberLimitRule.minValue;
      const maxNumberValue = numberLimitRule.maxValue;
      const numberLimitApplied = numberLimitRule.active;
      const numberLimitValidationMessage = numberLimitRule.message;

      const noNegativeRule = validationsRules.noNegative || {};
      const noNegative = noNegativeRule.active;
      const noNegativeValidationMessage = noNegativeRule.message;

      const onlyIntegerRule = validationsRules.onlyInteger || {};
      const onlyInteger = onlyIntegerRule.active;
      const onlyIntegerValidationMessage = onlyIntegerRule.message;

      const onlyDecimalRule = validationsRules.onlyDecimal || {};
      const onlyDecimal = onlyDecimalRule.active;
      const onlyDecimalValidationMessage = onlyDecimalRule.message;
      const triggerOnChange = (uiMetaData && uiMetaData.onChange) ? uiMetaData.onChange : false;

      if (uiMetaData && uiMetaData.currency) {
        return <FormattedInputs field={field} fieldName={fieldName} onChange={onChange} formMethods={formMethods} fieldValue={value}/>
      } else {
        return (
          <FormInput
            name={fieldName}
            label={field.name}
            isDisplayLabel={isDisplayLabel}
            isRequired={isRequired}
            isMask={uiMetaData?.fieldMask === 'True'}
            fieldDescription={isFixedHelpTooltip(field) ? formatHelpText(field.description) : null}
            fieldExternalLinkUrl={uiMetaData?.externalLinkUrl}
            fieldExternalLinkText={uiMetaData?.externalLinkText}
            value={value}
            ref={register({
              required: {
                value: isRequired,
                message: reqValidationMessage
              },
              validate: value => {
                const numberValue = value && Number(value);
                if(!numberValue){
                  return 'Field must be Required.'
                }
                if (isNaN(numberValue) || / |^\+|e|^-0+$|^-0+\.$|^-0+\.0+$/.test(value)) {  // if not a standard number or has + sign or in scientific notation
                  return 'Field must be a valid number.';
                }
                if (noNegative && numberValue < 0) {
                  return noNegativeValidationMessage;
                }
                if (onlyInteger && (!Number.isInteger(numberValue) || numberValue.toString() !== value)) {
                  return onlyIntegerValidationMessage;
                }
                if (numberLimitApplied && ((minNumberValue && (minNumberValue > numberValue)) || (maxNumberValue && (maxNumberValue < numberValue)))) {
                  return numberLimitValidationMessage;
                }
                if (onlyDecimal) {
                  const text = value.toString();   // using value controls unlimited 0s after decimal point.
                  const index = text.indexOf('.');
                  const decimalPlaces = index === -1 ? 0 : (text.length - index - 1);
                  if (decimalPlaces > 2 || (index >= 0 && (decimalPlaces === 0))) {
                    return onlyDecimalValidationMessage;
                  }
                }
              }
            })}
            error={errors[fieldName] || errors[field.identifier]}
            setValue={setValue}
            unregister={unregisterField}
            onChange={triggerOnChange ? (): void => onChange() : undefined}
          />
        );
      }
    case "date":
      const noFutureDatesRule = validationsRules.noFutureDates || {};
      const noFutureDates = noFutureDatesRule.active;
      const noFutureDatesValidationMsg = noFutureDatesRule.message;

      const noPastDatesRule = validationsRules.noPastDates || {};
      const noPastDates = noPastDatesRule.active;
      const noPastDatesValidationMsg = noPastDatesRule.message;

      const inputFormat = uiMetaData?.dateFormat || CONSTANTS.DEFAULT_DATE_FORMAT;
      const dateIsRequired = !!isRequired || !!noFutureDates || !!noPastDates;
      let minDate = noPastDates ? new Date() : new Date(CONSTANTS.DEFAULT_MIN_DATE);
      let maxDate = noFutureDates ? new Date() : new Date(CONSTANTS.DEFAULT_MAX_DATE);
      let minDateErrorMsg = '';
      if (fieldName === "lastFiscalYearEndDate") {
        const uiMetaDataDate: any = parseClassificationAttribute(field.classification);
        if (uiMetaDataDate && uiMetaDataDate.minYear) {
          const minYear = uiMetaDataDate.minYear.match(/(\d+)/)[0] || 1;
          const localMinDate = new Date(new Date(new Date().setFullYear(new Date().getFullYear() - Number(minYear))).setHours(0, 0, 0, 0));
          minDate = new Date(localMinDate.setDate(localMinDate.getDate() + 1));
          maxDate = new Date();
          minDateErrorMsg = uiMetaDataDate.errorMessage && uiMetaDataDate.errorMessage;
        }
      }

      return (
        <CalendarPicker
          name={fieldName}
          label={field.name}
          value={value}
          required={false}
          fieldDescription={formatHelpText(field.description)}
          inputFormat={inputFormat}
          views={inputFormat === 'MM/yyyy' ? ["year", "month"] : ["year", "month", "day"]}
          ref={register(fieldName, {
            required: {
              value: dateIsRequired,
              message: reqValidationMessage
            },
            validate: value => {
              const dateValue = moment(value);
              if (!dateValue.isValid()) {
                return CONSTANTS.INVALID_DATE_MSG;
              }
              if (moment(value).isBefore(minDate)) {
                return fieldName === "lastFiscalYearEndDate" && minDateErrorMsg !== '' ? minDateErrorMsg : noPastDatesValidationMsg || CONSTANTS.INVALID_DATE_MSG;
              }

              if (moment(value).isAfter(maxDate)) {
                return noFutureDatesValidationMsg || CONSTANTS.INVALID_DATE_MSG;
              }

            }
          })}
          error={errors[fieldName] || errors[field.identifier]}
          setValue={setValue}
          onChange={(e) => {
            if(fieldName === "lastFiscalYearEndDate") {
              const fyeDateValue = moment(e).endOf("month").startOf("day").format("YYYY-MM-DD[T]HH:mm:ss.SSS")
              setValue(fieldName, fyeDateValue, {
                shouldValidate: true,
                shouldDirty: true
              })
            }
            return onChange()
          }}
          minDate={minDate}
          maxDate={maxDate}
          unregister={unregisterField}
        />

      )
    case "selectLink":
      filteredLookupLinkList = lookupLinks.filter(x => x["lookupLinkId"] === field.dataField.propertyTypeId)[0];
      options = filteredLookupLinkList ? Object.keys(filteredLookupLinkList.properties) : [];

      return (
        <AutoComplete
          options={options}
          name={fieldName}
          label={field.name}
          value={value}
          setValue={setValue}
          disabled={field.isReadOnly}
          ref={register(fieldName, {
            required: {
              value: isRequired,
              message: reqValidationMessage
            }
          })}
          error={errors[fieldName] || errors[field.identifier]}
          required={isRequired}
          reqValidationMessage={reqValidationMessage}
          onChange={onChange}
          multiple={false}
          unregister={unregisterField}
        />
      )
    case "select":
    case "multiselect":
      const parentLookupLink: any = lookupLinks.find(x => x["childLookupId"] === field.dataField.propertyTypeId);
      
      
      if (parentLookupLink) {
        const parentLookupLinkName = requirementsInScope.find(requirementInScope => requirementInScope.dataField.propertyTypeId === parentLookupLink.lookupLinkId)?.dataField?.propertyName;
        options = (parentLookupLink.properties[getValues()[parentLookupLinkName]] || {}).childValues || [];
      }

      if (!options || options.length === 0) {
        filteredLookupList = lookupList.filter(x => x["lookupId"] === field.dataField.propertyTypeId)[0];
        options = filteredLookupList ? filteredLookupList["values"] : [];
      }
      
      let showAsterisk = false

      const validateMaxLimit = (value) => {
        if(field.dataField.propertyType === "multiselect" && value) {
          return value.split("|").length <= multiSelectMax;
        }
      }

      return (
        <AutoComplete
          options={options}
          name={fieldName}
          value={value}
          setValue={setValue}
          required={showAsterisk}
          disabled={field.isReadOnly}
          ref={register(fieldName, {
            required: {
              value: isRequired,
              message: reqValidationMessage
            },
            validate: {
              maxNumberValidation: (value) => { return (validateMaxLimit(value) || errorMessage)}
            }
          })}
          error={errors[fieldName] || errors[field.identifier]}
          reqValidationMessage={reqValidationMessage}
          onChange={onChange}
          multiple={field.dataField.propertyType === 'multiselect'}
          unregister={unregisterField}
        />
      )
    case "dataGroup":
      return (
        <FormDataGroups
          dataGroupName={field.dataField.propertyName}
          dataGroupId={field.dataField.propertyTypeId}
          dataGroupTitle={field.name}
          formMethods={formMethods}
          initialValues={initialValues}
          documents={documents}
          onChange={onChange}
          journeyId={journeyId}
          entityId={entityId}
          requirementsInScope={dataGroupReqsInScope}
          dynamicDataGroupRequirements={dynamicDataGroupRequirements}
          lookupList={lookupList}
          lookupLinks={lookupLinks}
          dataGroupsSettings={dataGroupsSettings}
          loading={loading}
          lookups={lookups}
          labelInsteadOfControl={labelInsteadOfControl}
          readOnly={readOnly}
          contentKey={uiMetaData?.contentType}
          uiMetaData={uiMetaData}
        />
      )
    default:
      return <strong>'{field.dataField.propertyType}' control is not supported.</strong>;
  }
}